<template>
	<v-hover>
		<template>
			<v-btn
				id="importarPlanilha"
				class="botao-primario botao-primario--icone"
				color="grey"
				outlined
				v-az-auth="permissoes.ataImportarQuantitativo"
				dense
				:disabled="isGeracaoEmProcessamento()"
				@click="emitirEvento"
			>
				<icone-tooltip
					v-if="isGeracaoEmProcessamento()"
					:icone="getIcon()"
					cor="primary"
					texto="Gerando modelo"
					class="mr-1"
					tamanho="0.9rem"
				></icone-tooltip>
				<div>{{ getNomeBotao() }}</div>
			</v-btn>
		</template>
	</v-hover>
</template>
<script>
import { mapState } from 'vuex'
import { actionTypes } from '@/core/constants'
import situacoes from '@/core/constants/situacao-zip-importar-quantitativo'

export default {
	name: 'botao-baixar-importar-prev-consumo',
	data() {
		return {}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
	},
	methods: {
		emitirEvento() {
			if (this.isGeracaoConcluida()) {
				this.$emit('importar-modelo')
				return
			}

			this.gerarModelo()
		},
		async gerarModelo() {
			await this.$store
				.dispatch(actionTypes.ATA.GERAR_MODELO_IMPORTAR_PREV_CONSUMO, this.informacoesAta.id)
				.then(() => {
					this.informacoesAta.statusModeloImportacao = situacoes.EM_PROCESSAMENTO.value
				})
				.catch(() => this.$emit('atualizar-ata'))
		},
		getIcon() {
			if (this.isGeracaoEmProcessamento()) return 'mdi-alert'
			return ''
		},
		getNomeBotao() {
			if (this.isGeracaoConcluida()) return 'Importar'
			return 'Gerar Modelo'
		},
		isGeracaoEmProcessamento() {
			return this.informacoesAta.statusModeloImportacao === situacoes.EM_PROCESSAMENTO.value
		},
		isGeracaoConcluida() {
			return this.informacoesAta.statusModeloImportacao === situacoes.CONCLUIDO.value
		},
	},
}
</script>

<style scoped lang="stylus">
.v-btn--disabled
	pointer-events auto
	cursor default

.botao-primario
	font-size (13 / 16)rem !important

	&__tamanhoLargura
		min-width 6.25rem !important;

.botao-primario.botao-primario--icone
	min-width (70 / 16)rem !important

	.v-btn__content
		justify-content normal !important
</style>
